import React from 'react';
import { TableHead } from './ui/table';
import { cn } from '../lib/utils';
import { ArrowUp, ArrowDown, ChevronsUpDown } from 'lucide-react';

export function SortableHeader({ label, sortKey, sortConfig, onSort, align = 'left', className }) {
  const active = sortConfig?.key === sortKey;
  const dir = active ? sortConfig.dir : null;
  const headClass = align === 'right' ? 'text-right' : align === 'center' ? 'text-center' : '';
  return (
    <TableHead className={cn(headClass, className)} aria-sort={active ? (dir === 'asc' ? 'ascending' : 'descending') : 'none'}>
      <button
        type="button"
        onClick={() => onSort(sortKey)}
        className="inline-flex items-center gap-1 font-medium select-none hover:text-slate-900"
        data-testid={'sort-' + sortKey}
      >
        <span>{label}</span>
        {dir === 'asc' && <ArrowUp className="h-3.5 w-3.5" />}
        {dir === 'desc' && <ArrowDown className="h-3.5 w-3.5" />}
        {!active && <ChevronsUpDown className="h-3.5 w-3.5 text-slate-300" />}
      </button>
    </TableHead>
  );
}
